import React from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useLang } from '@/i18n';

const ApplianceRatings = () => {
    const { t } = useLang('Delta3MaxSeriesStation.ApplianceRatings');
    return (
        <section className={`${styles.ApplianceRatings} GtmModuleData-section`} data-section-id={'ApplianceRatings'}>
            <div className="title">{t('title')}</div>
            <div className="content">
                <EcoImg
                    isOpenLazy
                    pc="https://websiteoss.ecoflow.com/upload/image/1757302168990/app-rink-1-pc.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1757302168990/app-rink-1-pc.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1757302171278/app-rink-1-m.jpg"
                    className="rating-img"
                />
            </div>
        </section>
    );
};

export default ApplianceRatings;
